import { Redirect, useLocation } from 'react-router';
import React from 'react';
import { LEAD_REPORT_URL, LOGIN_URL, BANK_PORTAL_BANKFEE_LIST, BANK_PORTAL_REPORT_POLICY_NEW, BANK_PORTAL_USER_LIST, BANK_PORTAL_CONTEST_LIST, BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE,BANK_PORTAL_REPORT_POLICY_NEW_AGB, BANK_PORTAL_REPORT_NAB_POLICY_NEW } from '../Routes';
import { connect } from 'react-redux';

const Component = ({ authenticated,isRoleBPBankfee,isRoleBPContest,isRoleBPReport,isRoleHO,isRoleBO,isRoleTO,isRoleBPAdmin, bank }) => {
  const { pathname } = useLocation();

  if (!authenticated) return <Redirect to={LOGIN_URL} />;

  console.log('==================== pathname ='+pathname)
  if (pathname === '/') {
    if(isRoleBPAdmin){
      return <Redirect to={BANK_PORTAL_USER_LIST} />;
    }
    if(isRoleBPBankfee){
      return <Redirect to={BANK_PORTAL_BANKFEE_LIST} />;
    }
    if(isRoleBPContest){
      return <Redirect to={BANK_PORTAL_CONTEST_LIST} />;
    }
    if(isRoleBPReport || isRoleHO || isRoleBO || isRoleTO ){
      if(bank === 'VCB'){
        return <Redirect to={BANK_PORTAL_REPORT_POLICY_NEW} />;
      }
      if(bank === 'HDB'){
        return <Redirect to={BANK_PORTAL_REPORT_POLICY_NEW_HDB_DIRECTSALE} />;
      }
      if(bank === 'AGR'){
        return <Redirect to={BANK_PORTAL_REPORT_POLICY_NEW_AGB} />;
      }
      if(bank === 'NAB'){
        return <Redirect to={BANK_PORTAL_REPORT_NAB_POLICY_NEW} />;
      }
      if(bank === 'FWD'){
        return <Redirect to={BANK_PORTAL_REPORT_POLICY_NEW} />;
      }
    }
    return <Redirect to={LEAD_REPORT_URL} />;
  }
  else return <Redirect to={pathname} />;
};

const mapStateToProps = (state) => {
  const authorities = state?.auth?.authorities;

  const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
  const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
  const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
  const isRoleBPReport = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_REPORT');
  const isRoleBPContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
  const isRoleBPBankfee = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_BANKFEE');
  const isRoleBPAdmin = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_ADMIN');

  const username = state?.auth?.name;
  const bank = state?.lookup?.bank;
  return {
    authenticated: state?.auth?.authenticated, isRoleHO, isRoleBPReport, isRoleBPAdmin, isRoleBPBankfee, isRoleBPContest, isRoleBO, isRoleTO, username, bank
  };
};

export default connect(mapStateToProps)(Component);
